class DataService {
  Time = Date.now();
  _Today = new Date(this.Time);
}
const Data = new DataService();
export default Data;
